import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { SanitizedHtml } from "@/components/common/sanitized-html";
import { ApiError } from "@/lib/api";
import { getWikiBySlug } from "@/features/knowledge/api";
import type { WikiPage } from "@/features/knowledge/types";

export default function WikiViewPage() {
  const { slug = "" } = useParams();
  const [page, setPage] = useState<WikiPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    getWikiBySlug(slug)
      .then(setPage)
      .catch((e) => {
        if (e instanceof ApiError && e.status === 404) setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="max-w-3xl space-y-3">
        <Skeleton className="h-8 w-2/3" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>
    );
  }

  if (notFound || !page) {
    return <p className="text-muted-foreground text-sm">This wiki page could not be found.</p>;
  }

  return (
    <article className="max-w-3xl">
      <h1 className="mb-4 text-2xl font-bold tracking-tight">{page.pageTitle}</h1>
      <SanitizedHtml html={page.content} />
    </article>
  );
}
